<app-page hideSidebar="true">
  <create-long-post></create-long-post>
</app-page>
